import { render, staticRenderFns } from "./OnlyToManager.vue?vue&type=template&id=531e7240&scoped=true&"
import script from "./OnlyToManager.vue?vue&type=script&lang=js&"
export * from "./OnlyToManager.vue?vue&type=script&lang=js&"
import style0 from "./OnlyToManager.vue?vue&type=style&index=0&id=531e7240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e7240",
  null
  
)

export default component.exports